<template>
  <DoubleColumn>
    <template #header>
      <section class="sm:flex sm:items-center sm:justify-between">
        <div class="sm:flex sm:space-x-5">
          <h1 class="text-3xl font-bold text-white">
            Neuen Podcast im Studio anlegen
          </h1>
        </div>
      </section>
    </template>
    <template #left>
      <section>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <h2>Gibst es deinen Podcast schon?</h2>
            <p class="mt-4 max-w-2xl text-sm text-gray-500">
              Willkommen in deinem Studio für Podcast-Wachstum. Starte bei Null oder importiere deinen öffentlichen Feed.
            </p>
          </div>
        </div>
      </section>
      <section>
        <TogglePanel>
          <template #header>
            <span>
              Vorhandenen RSS-Feed importieren
            </span>
          </template>
          <template #default>
            <div class="px-2 py-5 sm:px-6">
              <ImportForm :resource="resource1" :errors="errors1" />
            </div>
            <div class="px-6 pb-6 divide-y divide-gray-200">
              <div class="flex justify-end">
                <SubmitButton @click="onImport" :load="creating1">
                  Podcast importieren
                </SubmitButton>
              </div>
            </div>
          </template>
        </TogglePanel>
      </section>
      <section>
        <TogglePanel>
          <template #header>
            <span>
              Neuen Podcast anlegen
            </span>
          </template>
          <template #default>
            <div class="px-2 py-5 sm:px-6">
              <PodcastForm :resource="resource2" :errors="errors2" />
            </div>
            <div class="px-6 pb-6 divide-y divide-gray-200">
              <div class="flex justify-end">
                <SubmitButton @click="onCreate" :load="creating2">
                  Podcast erstellen
                </SubmitButton>
              </div>
            </div>
          </template>
        </TogglePanel>
      </section>
    </template>
    <template #right>
      <section>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <StepWizard :step="0" />
          </div>
        </div>
      </section>
    </template>
  </DoubleColumn>
</template>

<script setup>
import { computed } from 'vue';
import { useOnboardingRouter } from '@/router/routers';
import { useCreateResource } from '@/client/actions';

const router = useOnboardingRouter();

const importTarget = computed(() => '/api/podcasts:import');
const importAction = useCreateResource(importTarget);

const{
  resource: resource1,
  errors: errors1,
  message: message1,
  create: create1,
  creating: creating1
} = importAction;

const createTarget = computed(() => '/api/podcasts');
const createAction = useCreateResource(createTarget);

const {
  resource: resource2,
  errors: errors2,
  message: message2,
  create: create2,
  creating: creating2
} = createAction;

const onCancel = () => router.welcome();
const onSuccessManual = (id) => router.profile(id);
const onSuccessImport = (id) => router.confirm(id);
const onImport = () => create1(onSuccessImport);
const onCreate = () => create2(onSuccessManual);
</script>
